const assemblyOrderStatus :any = {
  DRAFT: 'draft',
  ISSUED: 'issued',
  IN_PROGRESS: 'in_progress',
  PAUSED: 'paused',
  COMPLETED: 'completed',
};

const assemblyOrderStatuses = [
  {
    label: 'Draft',
    value: assemblyOrderStatus.DRAFT,
  },
  {
    label: 'Issued',
    value: assemblyOrderStatus.ISSUED,
  },
  {
    label: 'In Progress',
    value: assemblyOrderStatus.IN_PROGRESS,
  },
  {
    label: 'Paused',
    value: assemblyOrderStatus.PAUSED,
  },
  {
    label: 'Completed',
    value: assemblyOrderStatus.COMPLETED,
  },
];

export const AssemblyOrderConfig = {
  assemblyOrderStatuses,
  assemblyOrderStatus,
};
